import { IAugmentedJQuery, IDirective, IDirectiveFactory, IAttributes, IScope } from "angular";
export class LazySrcWrapperController {
  private observer: IntersectionObserver;
  private isObserverBrowserSupported: boolean;

  public static $inject = ["$scope"];
  constructor(private $scope: IScope) {}

  public setWrapper(): void {
    this.isObserverBrowserSupported = this.checkIfObserverIsBrowserSupported();
    if (!this.isObserverBrowserSupported) {
      return;
    }

    const observerOptions: IntersectionObserverInit = {
      threshold: 0,
      rootMargin: "0px 0px 130px 0px",
    };

    this.observer = new IntersectionObserver(this.observerCallback, observerOptions);

    this.$scope.$on("$destroy", () => {
      this.observer.disconnect();
      this.observer = null;
    });
  }

  private observerCallback = (entries: IntersectionObserverEntry[], observer: IntersectionObserver): void => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const imageElement = entry.target;
        const imageSource = imageElement.getAttribute("lazy-src");
        imageElement.setAttribute("src", imageSource);
        observer.unobserve(imageElement);
      }
    });
  };

  public addImage(image: HTMLElement): void {
    if (!this.isObserverBrowserSupported) {
      image.setAttribute("src", image.getAttribute("lazy-src"));
      return;
    }
    this.observer.observe(image);
  }

  public removeImage(image: HTMLElement): void {
    if (!this.isObserverBrowserSupported) {
      return;
    }
    if (this.observer) {
      this.observer.unobserve(image);
    }
  }

  private checkIfObserverIsBrowserSupported = (): boolean => {
    return "IntersectionObserver" in window;
  };
}

export class LazySrcWrapper implements IDirective {
  public restrict = "A";
  public controller = LazySrcWrapperController;

  public link(scope: IScope, element: IAugmentedJQuery, attr: IAttributes, ctrl: LazySrcWrapperController): void {
    ctrl.setWrapper();
  }

  public static factory(): IDirectiveFactory {
    const directive = () => new LazySrcWrapper();
    directive.$inject = [];
    return directive;
  }
}
